/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../buttons/button/button.component.ngfactory';
import * as import2 from '../../buttons/button/button.component';
import * as import3 from '../../orchestration/session.model';
import * as import4 from '../../orchestration/responsive.service';
import * as import5 from '../../page-layout/page-footer-control.directive';
import * as import6 from '../../string-utils/currency.pipe';
import * as import7 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import8 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import9 from '../../orchestration/page';
import * as import10 from '../../orchestration/navigation.service';
import * as import11 from './tip-selection-page.component';
import * as import12 from '../tip-selection-panel/tip-selection-panel.component.ngfactory';
import * as import13 from '../tip-selection-panel/tip-selection-panel.component';
import * as import14 from '../../ordering-context/ordering-context.model';
import * as import15 from '../../order/order.model';
import * as import16 from '@angular/common';
const styles_TipSelectionPageComponent:any[] = ([] as any[]);
export const RenderType_TipSelectionPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_TipSelectionPageComponent,
  data: {}
}
);
function View_TipSelectionPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.applyTip(true)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import1.View_ButtonComponent_0,import1.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import2.ButtonComponent,[
      import0.ElementRef,
      import3.SessionModel,
      import0.ChangeDetectorRef,
      import4.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵppd(1),
    import0.ɵpod(['amount']),
      import0.ɵdid(16384,[[
        3,
        4
      ]
    ],0,import5.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.tip.confirmAndPay';
    const currVal_28:any = ck(v,3,0,import0.ɵunv(v,1,1,ck(v,2,0,import0.ɵnov((<any>v.parent),0),(co.orderModel.orderTotal + co.tipAmount))));
    ck(v,1,0,currVal_27,currVal_28);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
export function View_TipSelectionPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import6.CurrencyPipe,([] as any[])),
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),12,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import7.View_ModalPageLayoutComponent_0,import7.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import8.ModalPageLayoutComponent,[
      import9.Page,
      import10.NavigationService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import9.PageLayout,(null as any),[import8.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),4,1,'woa-tip-selection-panel',[[
        'class',
        'tip-selection'
      ]
    ],(null as any),[
      [
        (null as any),
        'tipAmountChange'
      ]
      ,
      [
        (null as any),
        'tipSelectedChange'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import11.TipSelectionPageComponent = v.component;
      if (('tipAmountChange' === en)) {
        const pd_0:any = ((<any>(co.tipAmount = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('tipSelectedChange' === en)) {
        const pd_1:any = ((<any>(co.tipSelected = $event)) !== false);
        ad = (pd_1 && ad);
      }
      if (('tipSelectedChange' === en)) {
        const pd_2:any = ((<any>co.applyTip(false)) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },import12.View_TipSelectionPanelComponent_0,import12.RenderType_TipSelectionPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import13.TipSelectionPanelComponent,[
      import14.OrderingContextModel,
      import15.OrderModel
    ]
    ,{
      tipAmount: [
        0,
        'tipAmount'
      ]
      ,
      tipSelected: [
        1,
        'tipSelected'
      ]

    }
    ,{
      tipAmountChange: 'tipAmountChange',
      tipSelectedChange: 'tipSelectedChange'
    }
    ),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,2,(null as any),View_TipSelectionPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import16.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import11.TipSelectionPageComponent = v.component;
    const currVal_0:any = co.title;
    const currVal_1:any = co.instructionParams;
    ck(v,3,0,currVal_0,currVal_1);
    const currVal_2:any = co.tipAmount;
    const currVal_3:any = co.tipSelected;
    ck(v,9,0,currVal_2,currVal_3);
    const currVal_4:any = (import0.ɵunv(v,12,0,import0.ɵnov(v,13).transform(co.SessionEvents.orderingPhase$)) === co.OrderingPhase.PAYMENT);
    ck(v,12,0,currVal_4);
  },(null as any));
}
function View_TipSelectionPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-tip-selection-page',([] as any[]),(null as any),(null as any),(null as any),View_TipSelectionPageComponent_0,RenderType_TipSelectionPageComponent)),
    import0.ɵdid(49152,(null as any),0,import11.TipSelectionPageComponent,[
      import10.NavigationService,
      import15.OrderModel,
      import14.OrderingContextModel
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import9.Page,(null as any),[import11.TipSelectionPageComponent])
  ]
  ,(null as any),(null as any));
}
export const TipSelectionPageComponentNgFactory:import0.ComponentFactory<import11.TipSelectionPageComponent> = import0.ɵccf('woa-tip-selection-page',import11.TipSelectionPageComponent,View_TipSelectionPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/payment/tip-selection-page/tip-selection-page.component.ngfactory.ts